import Vue from "vue";
import VueRouter from "vue-router";
import {MainLayout} from "@/components/mainLayout"
import index from "./modules/index"
import aftersale from "./modules/aftersale"
import company from "./modules/company"
import customerpool from "./modules/customerpool"
import system from "./modules/system"
import duesoon from "./modules/duesoon"
import history from "./modules/history"
import statistics from "./modules/statistics"
import waters from "./modules/waters"
import success from "./modules/success"
import config from "@/config"
Vue.use(VueRouter);

const router = new VueRouter({
    mode:'history',
    routes:[
        {
            path:'/',
            meta: {title: '首页'},
            component: MainLayout,
            children: [
                ...index,
                ...aftersale,
                company,
                customerpool,
                system,
                ...duesoon,
                ...history,
                statistics,
                ...waters,
                success
            ]
        },
        {
            name: '登录',
            path: '/login',
            component: ()=>import("@/pages/login/login.vue")
        }
    ]
})

router.beforeEach((to, from, next) => {
    window.document.title = config.title;
    next();
})
export default router;
